import styled, { css } from 'styled-components';

import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { Image } from 'components/Image';

const Hero = styled.section`
  position: relative;

  padding-top: 5rem;
  margin: 3rem 0;
`;

const HeroMedia = styled.div`
  width: 100%;
  min-height: 40rem;

  max-height: 80rem;
  height: 100%;

  ${mediaMinWidth.lg(css`
    & > * {
      height: 40rem;
    }
  `)}
`;

const HeroImg = styled(Image)`
  width: 100rem;
  height: 80rem;
`;

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Hero, HeroMedia, HeroImg, Center };
